// removed by extract-text-webpack-plugin
module.exports = {"container":"src-page-components-glass-detail----styles-module---container---v7BHb","topSection":"src-page-components-glass-detail----styles-module---topSection---1T8Rx","topLhs":"src-page-components-glass-detail----styles-module---topLhs---1K22Q","topRhs":"src-page-components-glass-detail----styles-module---topRhs---3656r","header":"src-page-components-glass-detail----styles-module---header---ZsKH3","contributeCta":"src-page-components-glass-detail----styles-module---contributeCta---1AGcx"};


//////////////////
// WEBPACK FOOTER
// ./src/page-components/glass-detail/styles.module.css
// module id = 649
// module chunks = 99110987824835